import React, { createContext, useContext, useEffect } from 'react';
import { useDocumentPiP } from './useDocumentPiP';
import { soundManager } from './sound';

interface PiPContextType {
  isSupported: boolean;
  isPiPActive: boolean;
  pipContainer: HTMLElement | null;
  pipWindow: Window | null;
  getWindow: () => Window;
  openPiP: (opts?: { width?: number; height?: number; title?: string }) => Promise<boolean>;
  closePiP: () => void;
  togglePiP: (opts?: { width?: number; height?: number; title?: string }) => Promise<void>;
}

const PiPContext = createContext<PiPContextType>({
  isSupported: false,
  isPiPActive: false,
  pipContainer: null,
  pipWindow: null,
  getWindow: () => window,
  openPiP: async () => false,
  closePiP: () => {},
  togglePiP: async () => {},
});

export const PiPProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const pip = useDocumentPiP({
    width: 440,
    height: 720,
    title: 'Pişti Online - Mini Pencere',
  });

  // Mini Masa aktif olduğunda otomatik olarak müzik & YouTube ses profilini (hafif sağ pan & yumuşak seviye) devreye al
  useEffect(() => {
    soundManager.setMusicMode(pip.isPiPActive);
    return () => {
      soundManager.setMusicMode(false);
    };
  }, [pip.isPiPActive]);

  return (
    <PiPContext.Provider value={pip}>
      {children}
    </PiPContext.Provider>
  );
};

export const usePiP = () => useContext(PiPContext);
